import { api } from './users';

export const getOrganizationAnalytics = async () => {
  const response = await api.get("/organizations/analytics/");
  return response.data;
};

/** @deprecated Prefer getOrganizationAnalytics */
export const getCompanyAnalytics = getOrganizationAnalytics;
